import FlightSegmentDetailsFlight from './flight-segment-details-flight-component';

import './flight-segment-details-flight.scss';

const MODULE_NAME = 'app.flight.segment.details.flight';
const module = angular.module(MODULE_NAME, [])
    .directive(FlightSegmentDetailsFlight.DIRECTIVE_NAME, FlightSegmentDetailsFlight);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-details-flight/flight-segment-details-flight-module.js